module.exports = __webpack_public_path__ + "img/introducePageFour_show_seven.edca649d.jpg";